import { SERVER_FULL_NAME } from 'mk/autogenerated/translations/structuredData.ed8ddddf54cbda2550e7884f371547f3'
import assetUrl from 'mk/common/assetUrl';
import { photoUrl } from 'mk/photo/photoUrl';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import * as homeUrls from 'mk2/apps/home/urls';
import { ACTIVE_SERVER_URL } from 'mk2/helpers/urls';
import { PhotoEntity } from 'mk2/schemas';

export const organizationModrykonik = (full: boolean = true): object => full
    ? {
        // according to https://developers.google.com/search/docs/data-types/article#amp
        '@context': 'http://schema.org',
        '@type': 'Organization',
        '@id': ACTIVE_SERVER_URL + homeUrls.homepage,
        'url': ACTIVE_SERVER_URL + homeUrls.homepage,
        'name': SERVER_FULL_NAME,
        'logo': {
            '@type': 'ImageObject',
            'url': assetUrl + `img/logos/ver-4/logo-organization-${ACTIVE_SERVER_ID}@1x.png`,
            'height': 60,
            'width': {201: 269, 202: 269, 207: 376}[ACTIVE_SERVER_ID],
        },
    } : {
        '@type': 'Organization',
        '@id': ACTIVE_SERVER_URL + homeUrls.homepage,
    };

export function mainImageUrlWithFallback(photos: PhotoEntity | PhotoEntity[]): string {
    const mainPhoto: PhotoEntity = Array.isArray(photos)
        ? (photos.length > 0 ? photos[0] : undefined)
        : photos;

    // according to https://developers.google.com/search/docs/data-types/article#amp
    //
    // Images should be at least 1200 pixels wide.
    return mainPhoto
        ? photoUrl(mainPhoto, 's1600x1600')
        : assetUrl + 'img/general/article-main-img-fallback@1x.png';
}
